"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlatformShippingStatus = void 0;
const PlatformShippingStatus = {
  OPEN: 1,
  READY: 2,
  SENT: 3,
  DELIVERED: 4,
  CLOSED: 5,
  CANCELLED: 6
};
exports.PlatformShippingStatus = PlatformShippingStatus;